'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Header - Vue Instance
----------------------------*/

if (document.querySelector('#header-vue')) {
  new _vue2.default({
    el: '#header-vue',
    delimiters: ['${', '}'],
    store: _store2.default,
    mounted: function mounted() {
      this.hydrateCartItems();
    },
    methods: Object.assign({}, (0, _vuex.mapActions)('cart', ['hydrateCartItems', 'toggleMiniCart']), {
      formatMoney: function formatMoney(price) {
        return currency.formatMoney(price);
      }
    }),
    computed: Object.assign({}, (0, _vuex.mapState)('cart', {
      checkoutUrl: function checkoutUrl(state) {
        return state.checkoutUrl;
      }
    }), (0, _vuex.mapGetters)('cart', ['cartSubtotal', 'cartCount']))
  });
}